<template>
  <div>
	<div class="row">
    <div class="col-md-12" style="display: block ruby;">
		  <h1 class="">Market Value</h1>
    </div>
    
    <div class="col-sm-12">
      <div class="pull-right form-group">
        <label>Market Value for </label>
        <div class="input-group">
          <date-picker :disabled-date="disabledDates" input-class="form-control" ref="market_date" value-type="format" v-model="tableData.market_date" format='DD-MM-YYYY' readonly></date-picker>
          <div class="input-group-append">
            <a class="btn btn-sm btn-info" :href="sample_download_url" target="_blank"><i class="fa fa-download" /></a>
          </div>
        </div>
        <div class="mt-2" style="display:flow-root;" v-if="can_access('marketvalue','upload')">

          <a href="javascript:;" class="pull-right ml-3" @click="showModal('default-margin-rate')" v-if="can_access('marketvalue','upload')">Upload Market Value CSV</a>

          <a href="javascript:;" class="pull-right" title="Change Account Margin Rate" @click="AccountMarginRate">Change Account Margin Rate</a>
        </div> 
      </div>
      <div class="pull-right form-group mr-3">
        <label>Custodian </label>
          <b-input-group>
            <select name="type" ref="custodian" class="form-control" v-model="tableData.custodian_id">
              <option selected value=0>Default (Client)</option>
              <option selected value=1000>Default (Broker)</option>
              <option v-for="custodian in custodians" :key="custodian.id" :value="custodian.id">{{custodian.name}}</option>
            </select>
          </b-input-group>
      </div>
    </div>
		<TableView :col="columns" :getData="getData" v-if="!refreshView"/>
    <div class="col-sm-12" v-if="can_access('marketvalue','modify')">
      <b-button class="btn btn-lg btn-info pull-right" title="Save Market Values" @click="addMarketValue"><i class="fa fa-save"></i> Save</b-button>
    </div>
	</div>
  <b-modal ref="account-margin-rate" title="Change Account Margin Rate" size="lg" hide-footer v-if="showAddAccountMarginRate && can_access('marketvalue','modify')">
      <div class="col-sm-12"><MarginRatePage :type="'account'"/></div>
  </b-modal>

  <b-modal ref="default-margin-rate" title="Default Margin Rate" size="lg" hide-footer v-if="showAddDefaultMarginRate && can_access('marketvalue','modify')">
      <div class="col-sm-12">
        <b-card no-body class="box-shadow">
          <b-tabs>
            <b-tab @click="activeTab='multi_date'" :active="activeTab=='multi_date'" title="Multiple Days">
              <MarginRatePage :type="'default'"/>       
              <b-button class="btn btn-lg btn-info pull-right" title="Confirm Default Market Values" @click="confirmMarketValue">Next <i class="fa fa-arrow-right"></i></b-button>      
            </b-tab>
            <b-tab @click="activeTab='single_date'" :active="activeTab=='single_date'" title="Single Day">
              <p class="my-4"><UploadDealTicketForm @forceRerender="uploadMarketValueFormReRender" :uri="upload_url"/></p>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
  </b-modal>

  <b-modal ref="upload-deal-ticket-out" title="Upload Market Values" size="xl" hide-footer v-if="can_access('marketvalue','upload')">
    <p class="my-4"><UploadDealTicketForm @forceRerender="uploadMarketValueFormReRender" uri="import_market_value" sample_file="market_value_sample" note="*As like as in the sample file first column must be date, and for the further columns you can add/remove the new/existing security ticker name"/></p>
  </b-modal>
  </div>
</template>
<script>
import moment from 'moment';
import common from '@/assets/js/common.js';

export default {
  name: 'MarketValuePage',
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
    DatePicker : () => import('vue2-datepicker') ,
    Widget : () => import('@/components/Widget/Widget') ,
    UploadDealTicketForm : () => import('@/components/Accounts/UploadTradesCSV'),
    MarginRatePage : () => import('@/pages/Accounts/MarginRate')
  },
  mixins: [common],
  data() {
    return {
      activeTab: 'single_date',
      showAddAccountMarginRate: true,
      showAddDefaultMarginRate: true,
    	tableData: {
        'market_date': this.getLastWorkingDate(),
        'custodian_id': 0,
      },
      custodians: [],
      refreshView: false,
      errorMessage: null,
      sample_download_url: '',
      upload_url: '',
      columns: (() => {
        const cols = [
          { title: 'Stock Name', field: 'stock_name', sortable: true, thComp: 'FilterTh', tdStyle: {padding: "0.8rem !important"} },
          { title: 'Ticker', field: 'ticker', sortable: true, thComp: 'FilterTh' },
          { title: 'ISIN', field: 'ISIN', sortable: true, thComp: 'FilterTh' },
          { title: 'Market Price', field: 'market_value', sortable: false, tdComp: 'Input' },
          { title: 'CFD Margin %', field: 'margin', sortable: false, tdComp: 'Input'},
          { title: 'Cash Margin %', field: 'cash_margin', sortable: false, tdComp: 'Input'}
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('marketvalue', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  watch: {
    'tableData.market_date': function(newValue){
      if(moment(newValue,'DD-MM-YYYY').isBefore(moment())){
        this.refreshView = true;
        this.$nextTick(function(){
          this.refreshView = false;
        });
      }else{
        this.tableData.market_date = moment().subtract(1, 'days').format("DD-MM-YYYY");
      }
      this.updateData();
    },
    'tableData.custodian_id': function(newValue){
      this.refreshView = true;
      this.$nextTick(function(){
        this.refreshView = false;
      });
      this.updateData();
    }
  },
  methods: {
    showModal(model) {
      this.$refs[model].show()
    },
    confirmMarketValue(){
      this.$refs['default-margin-rate'].hide()
      this.showModal('upload-deal-ticket-out');
    },
    uploadMarketValueFormReRender(response){
      //if(response.code==0){
        this.$refs['default-margin-rate'].hide()
          this.$refs['upload-deal-ticket-out'].hide()
          this.refreshView = true;
          this.$nextTick(function(){
            this.refreshView = false;
          });
      //}
    },
    updateData() {
      this.upload_url = 'single_day_import_market_value?market_date='+this.tableData.market_date+'&custodian_id='+this.tableData.custodian_id
      this.sample_download_url = this.get_baseURL()+'export_market_data?market_date='+this.tableData.market_date+'&custodian_id='+this.tableData.custodian_id+'&api_token='+ window.localStorage.getItem('auth_token')
    },
    AccountMarginRate(){
      this.$refs['account-margin-rate'].show()
    },
    async getCustodian(){
      const {response} = await this.call_axios('get_custodians');
      this.custodians = response.data;     
    },
    async getData(query, filter) {
      const { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      filter['market_date'] = this.tableData.market_date;
      filter['custodian_id'] = this.tableData.custodian_id;
			let uri = 'get_instruments_by_trades?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
			const res = await this.call_axios(uri);
			//res.response.data.Pagination = false;
			this.tableData =  {
        'market_date': this.tableData.market_date,
        'custodian_id': this.tableData.custodian_id
      };
      Object.assign(this.tableData, res.response.data.result);
      this.updateData();
			return res;
    },
    addMarketValue: async function(){
      //console.log(this.tableData,this.tableData.market_date)
      const {response} = await this.call_axios('add_market_value', 'post', {data:this.tableData}); 
      this.$toasted.success("Successfully Added",{duration:1000});    
    },
    disabledDates(date){
      if(moment(date).isAfter(moment())) return true;
      return false;
    }
  },
  created() {
    this.getCustodian()
  },
};
</script>
<style scoped>
.mx-datepicker {
  width: 93% !important;
}
</style>